var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBgRedPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "#F70303"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4522_31140)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.7388 28.4136C33.5716 29.6839 32.9477 30.85 31.9837 31.6939C31.0196 32.5379 29.7813 33.0021 28.5 32.9998C21.0563 32.9998 15 26.9436 15 19.4998C14.9977 18.2185 15.4619 16.9802 16.3059 16.0161C17.1499 15.0521 18.3159 14.4282 19.5863 14.2611C19.9075 14.2218 20.2328 14.2876 20.5136 14.4484C20.7944 14.6093 21.0157 14.8566 21.1444 15.1536L23.1244 19.5739V19.5851C23.2229 19.8124 23.2636 20.0606 23.2428 20.3074C23.222 20.5543 23.1404 20.7922 23.0053 20.9998C22.9884 21.0251 22.9706 21.0486 22.9519 21.072L21 23.3857C21.7022 24.8126 23.1947 26.292 24.6403 26.9961L26.9222 25.0545C26.9446 25.0357 26.9681 25.0181 26.9925 25.002C27.2 24.8636 27.4387 24.7792 27.687 24.7562C27.9353 24.7333 28.1854 24.7727 28.4147 24.8707L28.4269 24.8764L32.8434 26.8554C33.1409 26.9837 33.3889 27.2047 33.5503 27.4856C33.7116 27.7664 33.7778 28.092 33.7388 28.4136Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4522_31140"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgRedPhone);
export default __webpack_public_path__ + "static/media/BgRedPhone.656ca6b9c342c8e32c14a7d81b0b1cd8.svg";
export { ForwardRef as ReactComponent };